import type { App } from 'vue';
import { VueQueryPlugin } from '@tanstack/vue-query';
import { tanstackOptions } from './tanstack-query.config';

export default {
  install(app: App) {
    app.use(VueQueryPlugin, tanstackOptions);
  },
};
